module.exports = __webpack_public_path__ + "static/use-case-3-content-1-e8ce147f1132049c2adee913057c5b20.png";